export default {
    deviceAdd: {
        method: 'POST',
        url: '/posadmin/device/add',
        name: '腕卡新增',
    },
    deviceDelete: {
        method: 'DELETE',
        url: '/posadmin/device/delete/{id}',
        name: '腕卡设备删除',
    },
    deviceExport: {
        method: 'POST',
        url: '/posadmin/device/export',
        name: '导出',
    },
    deviceList: {
        method: 'POST',
        url: '/manage-system/bracelet/list',
        name: '腕卡设备列表',
    },
    // deviceList: {
    //     method: 'POST',
    //     url: '/posadmin/device/list',
    //     name: '腕卡设备列表',
    // },
    deviceEdit: {
        method: 'POST',
        url: '/posadmin/device/update',
        name: '腕卡编辑',
    },
    deviceDetial: {
        method: 'GET',
        url: '/posadmin/device/{id}',
        name: '根据腕卡id获取腕卡设备',
    },

    warnsetAdd: {
        method: 'POST',
        url: '/posadmin/warnset/add',
        name: '告警设置新增',
    },
    warnsetList: {
        method: 'POST',
        url: '/posadmin/warnset/list',
        name: '告警设置列表',
    },
    warnsetState: {
        method: 'GET',
        url: '/posadmin/warnset/startforb/{id}/{status}',
        name: '启用 禁用',
    },
    warnsetEdit: {
        method: 'POST',
        url: '/posadmin/warnset/update',
        name: '告警设置编辑',
    },
    warnsetDetail: {
        method: 'GET',
        url: '/posadmin/warnset/{id}',
        name: '根据id获取告警设置',
    },

    warnState: {
        method: 'POST',
        url: '/posadmin/warn/deal',
        name: '告警处理',
    },
    warnExport: {
        method: 'POST',
        url: '/posadmin/warn/export',
        name: '导出',
    },
    warnList: {
        method: 'POST',
        url: '/posadmin/warn/list',
        name: '告警记录列表',
    },
    warnDetail: {
        method: 'GET',
        url: '/posadmin/warn/{id}',
        name: '根据id获取告警记录',
    },
}
